export default "/app/global-wrapper-client/static/8f3d74fd1fad4c2dc11e647d14adc96c.ttf";